import ICasRenderCellProps from '../ICasRenderCellProps';
import CasBooleanIcon from '../../CasIcon/CasBooleanIcon';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderBoolTrue(props: ICasRenderCellProps) {
  return <CasBooleanIcon value={getCasTableCellValue(props)} falseIcon={false} />;
}

export function CasRenderBoolTrueFalse(props: ICasRenderCellProps) {
  return <CasBooleanIcon value={getCasTableCellValue(props)} falseIcon />;
}
